import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  .block-subtitle {
    padding-bottom: 8px;
  }

  .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .plan-date {
    margin-top: 10px;
  }
`;

const getTimeStr = (desiredDeliveryTimeFrom, desiredDeliveryTimeTo) => {
  if (!desiredDeliveryTimeFrom) {
    return `до ${desiredDeliveryTimeTo}`;
  }

  if (!desiredDeliveryTimeTo) {
    return `с ${desiredDeliveryTimeFrom}`;
  }

  return `${desiredDeliveryTimeFrom} - ${desiredDeliveryTimeTo}`;
};

const TimeAndDate = (props) => {
  const { delivery, currentOrder, isFbmType } = props;

  const { t } = useAutoTranslation();

  return (
    <Wrapper className="mt-2">
      {(isFbmType ||
        delivery?.deliveryCode !== 'Samovyvoz' ||
        delivery?.type !== 'SELF_PICKUP' ||
        (delivery?.type === 'COURIER' && currentOrder?.isMarketplaceOrder === false)) && (
        <>
          <div className="block-subtitle">{t('Желаемая дата доставки')}</div>
          <div className="inner">
            {delivery?.desiredDeliveryDate ? (
              <div>
                <i className="fe-calendar mr-1" />
                {moment(delivery?.desiredDeliveryDate, 'YYYY-MM-DD').format('DD.MM.YYYY')}
              </div>
            ) : null}

            {delivery?.desiredDeliveryTimeFrom || delivery?.desiredDeliveryTimeTo ? (
              <div>
                <i className="fe-clock mr-1" />
                {getTimeStr(delivery.desiredDeliveryTimeFrom, delivery.desiredDeliveryTimeTo)}
              </div>
            ) : null}
          </div>
        </>
      )}
      {(currentOrder.type === 'SELF_PICKUP' ||
        delivery?.deliveryCode === 'Samovyvoz' ||
        isFbmType ||
        (currentOrder?.isMarketplaceOrder && currentOrder.plannedTakeOutDate)) && (
        <div className="mt-2">
          <div className="block-subtitle">{t('Плановая дата отгрузки')}</div>
          <p className="mt-1">
            <i class="fe-calendar mr-1"></i>
            {currentOrder?.plannedTakeOutDate
              ? moment(currentOrder.plannedTakeOutDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
              : t('Дата не установлена')}
          </p>
        </div>
      )}
    </Wrapper>
  );
};

export default TimeAndDate;
